import { resolve, reject } from 'redux-optimist-promise';
import { get } from 'lodash';
import createReducer from 'Store/utils/createReducer';
import { PRICE_TICKET_REQUEST } from './constants';
const initialState = {
  isLoading: true,
  productArgs: '',
  price: {} as ProductPrice,
};
type PriceTicketState = typeof initialState;

export default createReducer<PriceTicketState>(initialState, {
  [PRICE_TICKET_REQUEST](state: PriceTicketState, action: PriceTicketRequestResolvedAction) {
    return { ...state, isLoading: true, productArgs: action.payload?.productArgs };
  },

  [resolve(PRICE_TICKET_REQUEST)](
    state: PriceTicketState,
    action: PriceTicketRequestResolvedAction,
  ): PriceTicketState {
    const price = get(action, 'payload.price') || ({} as ProductPrice);
    return { ...state, isLoading: false, price: price as ProductPrice };
  },

  [reject(PRICE_TICKET_REQUEST)](state: PriceTicketState): PriceTicketState {
    return { ...state, isLoading: false };
  },
});
